/**
 * Upstream hills beyond the northern crossing (lifted from lantern-water's
 * `world.js` `createTown`): nine grassy domes alternating east and west, each
 * kept wholly outside the widening river (`river-course.ts`), sunk to -2.
 * Placed at the origin (they stand where the river leaves them room). Its own
 * random stream. No params.
 */
import * as THREE from 'three';
import { riverCoast } from '../river-course.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'distant_hills',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { mesh, random, m, kit } = ctx;
    const dome = kit.shared('distant-hills:dome', () => new THREE.SphereGeometry(1, 16, 10));
    for (let i = 0; i < 9; i += 1) {
      const z = -49 - random() * 32;
      const radius = 10 + random() * 5;
      const height = 5 + random() * 5;
      const depth = 12 + random() * 6;
      const east = i % 2 === 1;
      // Keep the entire hill footprint outside the widened river corridor.
      const edge = east ? Math.max(riverCoast(z - depth, true), riverCoast(z + depth, true)) : Math.min(riverCoast(z - depth, false), riverCoast(z + depth, false));
      const hill = mesh(root, dome, m.grass, edge + (east ? 1 : -1) * (radius + 3), -2, z, radius, height, depth);
      hill.name = 'upstream-bank-hill';
      hill.castShadow = false;
    }
    return { root };
  },
};
